import { SUPPLIERS_TYPES_IDS } from '@wyz/utils';
import { TranslationKeys } from '~/common/types';

export const SUPPLIER_TYPE_ID_TRANSLATIONS: Record<
  number,
  keyof TranslationKeys
> = {
  [SUPPLIERS_TYPES_IDS.CENTRAL_STOCK]: 'app.supplier_types.central_stock',
  [SUPPLIERS_TYPES_IDS.WYZ_DISTRIBUTOR]: 'app.supplier_types.wyz_distributor',
  [SUPPLIERS_TYPES_IDS.MANUFACTURER]: 'app.supplier_types.manufacturer',
  [SUPPLIERS_TYPES_IDS.SPECIALIST]: 'app.supplier_types.specialist',
  [SUPPLIERS_TYPES_IDS.PLATFORM_DISTRIBUTOR]: 'app.common.customer.local_stock',
  [SUPPLIERS_TYPES_IDS.WHOLESALER]: 'app.supplier_types.wholesaler',
};
export const PRICING_POLICY_SUPPLIER_TYPE_TRANSLATIONS: Record<
  number,
  keyof TranslationKeys
> = {
  ...SUPPLIER_TYPE_ID_TRANSLATIONS,
  [SUPPLIERS_TYPES_IDS.PLATFORM_DISTRIBUTOR]: 'app.common.customer.local_stock',
};
